import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import BlogPost from "../BlogPost";
import { getUser, removeUser } from "../utils/auth";
import { clearPenStorage } from "../utils/penStorage";

export default function BlogPostPage() {
  const navigate         = useNavigate();
  const { slug }         = useParams();
  const [user, setUser]  = useState(getUser);

  const handleLogout = () => {
    removeUser();
    setUser(null);
    navigate('/');
  };

  const handleNewPen = () => {
    clearPenStorage();
    navigate('/editor');
  };

  return (
    <BlogPost
      slug={slug}
      user={user}
      onGoHome={() => navigate('/')}
      onGoBlog={() => navigate('/blog')}
      onEditor={() => navigate('/editor')}
      onExplore={() => navigate('/explore')}
      onLogin={() => navigate('/login')}
      onNewPen={handleNewPen}
      onViewPens={() => navigate('/editor?pens=true')}
      onSettings={() => navigate('/editor?settings=true')}
      onLogout={handleLogout}
    />
  );
}
